import { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, FormField, Modal } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Strings from "constants/strings";
import TagService from "services/medkit/tag.service";

import { IRecordTag } from "commons/interfaces";
import { setDataAlert } from "store/slice/common.slice";



const tagService = new TagService();

const ModalAddTag = ({
    visible,
    setVisible,
    onCallBack,
}: {
    visible: boolean;
    onCallBack: (data: IRecordTag) => void;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) => {

    const dispatch = useDispatch();
    const [tagName, setTagName] = useState("");
    const [errorTagName, setErrorTagName] = useState("");

    const handleCloes = () => {
        setVisible(false);
        setErrorTagName("");
        setTagName("");
    };

    const handleSubmit = async () => {
        if (Helpers.isNullOrEmpty(tagName.trim())) {
            setErrorTagName(Strings.REPORT.PLEASE_ENTER_TAG_NAME);
        } else {
            try {
                const result = await tagService.create({ tagName: tagName });
                dispatch(setDataAlert({ message: Strings.REPORT.CREATE_TAG_SUCCESS, type: "success" }));
                onCallBack(result);
            } catch (error) {
                const err = Helpers.handleExceptionError(error);
                !Helpers.isNullOrEmpty(err) && dispatch(setDataAlert({ message: err, type: "error" }));
            } finally {
                handleCloes();
            }
        }
    };

    return (
        <Modal
            fullWidth
            hasActionButton
            maxWidth={"sm"}
            visible={visible}
            title={Strings.REPORT.ADD_NEW_TAG}
            onClose={() => { handleCloes(); }}
            onAction={() => { handleSubmit(); }}
        >
            <Box padding={"0px 16px"}>
                <FormField
                    variant={"outlined"}
                    defaultValue={tagName || ""}
                    errorMessage={errorTagName || ""}
                    placeholder={Strings.REPORT.ENTER_TAG_NAME}
                    onBlur={(value) => {
                        setTagName(value);
                        setErrorTagName("");
                    }}
                />
            </Box>
        </Modal>
    );
}

export default ModalAddTag;